/**
 * ============================================================
 * SynlabAdminNavbar.js — Navigation Bar for Admin Panel
 * ============================================================
 *
 * Provides easy navigation between all admin tools:
 *   - Dashboard
 *   - People
 *   - Projects
 *   - Publications
 *   - Admin Users
 *
 * Design:
 *   - Minimal, clean admin layout that is distinct from public site
 *   - Sticky top bar for convenient navigation
 *   - Logo links back to the public homepage
 **/

import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import { NavLink, Link, useLocation } from "react-router-dom";

import "./css/SynlabAdminNavbar.css";


// ------------------------------------------------------------
// Component
// ------------------------------------------------------------
function SynlabAdminNavbar() {

  const location = useLocation();
  const isActive = (path) => location.pathname.startsWith(path);

  // ----------------------------------------------------------
  // Render
  // ----------------------------------------------------------
  return (
    <>
      <Navbar expand="md" className="admin-navbar" fixed="top">
        <div className="admin-navbar-inner">

          {/* ----- LOGO (links to public homepage) ----- */}
          <Navbar.Brand as={Link} to="/" className="admin-navbar-logo">
            <img
              src="/logos/synlab-logo.png"
              alt="Synlab Logo"
              className="admin-logo-img"
            />
          </Navbar.Brand>

          {/* ----- MOBILE TOGGLE BUTTON ----- */}
          <Navbar.Toggle aria-controls="admin-navbar-collapse" className="admin-navbar-toggle" />

          {/* ----- COLLAPSIBLE ADMIN MENU ----- */}
          <Navbar.Collapse id="admin-navbar-collapse" className="justify-content-end">
            <Nav className="admin-navbar-links">

              <Nav.Link
                as={NavLink}
                to="/admin/dashboard"
                className={isActive("/admin/dashboard") ? "active" : ""}
              >
                Dashboard
              </Nav.Link>

              <Nav.Link
                as={NavLink}
                to="/admin/people"
                className={isActive("/admin/people") ? "active" : ""}
              >
                People
              </Nav.Link>

              <Nav.Link
                as={NavLink}
                to="/admin/projects"
                className={isActive("/admin/projects") ? "active" : ""}
              >
                Projects
              </Nav.Link>

              <Nav.Link
                as={NavLink}
                to="/admin/publications"
                className={isActive("/admin/publications") ? "active" : ""}
              >
                Publications
              </Nav.Link>

              <Nav.Link
                as={NavLink}
                to="/admin/users"
                className={isActive("/admin/users") ? "active" : ""}
              >
                Admin Users
              </Nav.Link>


            </Nav>
          </Navbar.Collapse>

        </div>
      </Navbar>

      {/* Spacer so content doesn't hide behind fixed navbar */}
      <div className="admin-navbar-spacer"></div>
    </>
  );
}

export default SynlabAdminNavbar;
